const isEvoVerificationStatus = (verificationStatus) => ["success", "pending", "failed"].includes(verificationStatus);
export const getEvoVerificationStatus = (verificationStatus) => isEvoVerificationStatus(verificationStatus) ? verificationStatus : "pending";
//# sourceMappingURL=getOptionalData.js.map